"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SundryTools_1 = require("./SundryTools");
const moment = require("moment");
/**
 * edit distance calculation , greater more similar
 * @param str1 compariable 1
 * @param str2 compariable 2
 */
function editDistance(str1, str2) {
    const l1 = str1.length;
    const l2 = str2.length;
    const superMatrix = [];
    // init levenshtein matrix 初始化 乐文斯坦矩阵 >w<
    for (let i = 0; i < l2 + 1; i++) {
        superMatrix[i] = [];
        for (let j = 0; j < l1 + 1; j++) {
            if (i === 0) {
                superMatrix[i][j] = j;
            }
            else if (j === 0) {
                superMatrix[i][j] = i;
            }
            else {
                superMatrix[i][j] = 0;
            }
        }
    }
    // distance calculation
    let temp = 0;
    for (let i = 1; i < l2 + 1; i++) {
        for (let j = 1; j < l1 + 1; j++) {
            if (str2[i - 1] === str1[j - 1]) {
                temp = 0;
            }
            else {
                temp = 1;
            }
            const compariables = [superMatrix[i - 1][j] + 1, superMatrix[i][j - 1] + 1, superMatrix[i - 1][j - 1] + temp];
            const min = Math.min(...compariables);
            superMatrix[i][j] = min;
        }
    }
    const comparison = 1 - superMatrix[l2][l1] / Math.max(l1, l2);
    return Math.round(comparison * 10000) / 10000;
}
exports.editDistance = editDistance;
/**
 * similarity of 2 numbers calculation, greater more similar
 * @param number1
 * @param number2
 */
function numberDeviation(number1, number2) {
    if (number1 === 0) {
        return 0;
    }
    return (Math.round((1 - Math.abs((number1 - number2) / number1)) * 1000) / 1000);
}
exports.numberDeviation = numberDeviation;
/**
 * coord distance sphere { lat: number, lng: number}
 * unit: meters
 * @param coords
 */
function coordDistance(coords) {
    const earthR = 6371;
    const degreesToRadians = (degrees) => { return (degrees * Math.PI / 180); };
    const degreesLat = degreesToRadians(coords[1].lat - coords[0].lat);
    const degreesLon = degreesToRadians(coords[1].lng - coords[0].lng);
    const lat1 = degreesToRadians(coords[0].lat);
    const lat2 = degreesToRadians(coords[1].lat);
    const a = Math.pow(Math.sin(degreesLat / 2), 2) + Math.pow(Math.sin(degreesLon / 2), 2) * Math.cos(lat1) * Math.cos(lat2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return Math.round(earthR * c * 1000 * 100) / 100;
}
exports.coordDistance = coordDistance;
/**
 * if the number is in the range
 * @param num to hit number
 * @param range *-* format range
 */
function isHitRange(num, range) {
    const pattern = new RegExp(/[0-9]*-[0-9]*/);
    if (pattern.exec(range)) {
        const lower = Number(range.split('-')[0]);
        const upper = Number(range.split('-')[1]);
        return num >= lower && num <= upper ? true : false;
    }
    else {
        const answer = { status: SundryTools_1.AnswerStatus.Failed, detail: 'Incorrect range format.' };
        return (answer);
    }
}
exports.isHitRange = isHitRange;
/**
 * timestamp converter
 * @param dt timstamp format date ( xxxx-xxxx ) version
 */
function timestampConvert(timst) {
    if (SundryTools_1.simpleDetect(timst) && SundryTools_1.isMatchRegex(timst, /([a-zA-Z0-9]*-[a-zA-Z0-9]*)/)) {
        let dt = timst.split('(')[1].split(')')[0].split('-')[0];
        dt = moment(Number(dt)).format() || '';
        return dt || null;
    }
    else {
        const answer = { status: SundryTools_1.AnswerStatus.Failed, detail: 'Bad input or incorrect format' };
        return (answer);
    }
}
exports.timestampConvert = timestampConvert;
/**
 * linear Regression function
 * @param condition > < >= <= =
 * @param y dependent
 * @param x independent
 * @param linearFuntion
 */
function linearReg(condition, y, x, linearFuntion = (thisx) => { const thisy = thisx; return thisy; }) {
    switch (condition) {
        case SundryTools_1.justOperator.Equal: {
            return linearFuntion(x) === y ? true : false;
        }
        case SundryTools_1.justOperator.Greater: {
            return linearFuntion(x) > y ? true : false;
        }
        case SundryTools_1.justOperator.Greaterequal: {
            return linearFuntion(x) >= y ? true : false;
        }
        case SundryTools_1.justOperator.Less: {
            return linearFuntion(x) < y ? true : false;
        }
        case SundryTools_1.justOperator.Lessequal: {
            return linearFuntion(x) <= y ? true : false;
        }
    }
}
exports.linearReg = linearReg;
//# sourceMappingURL=MathMatic.js.map